import React, { Component } from 'react';
import mp3_file from './sarvmangal.mp3';

const Audio = function(props) {
  return (
    <audio style={{display: 'none'}} src={mp3_file} controls autoPlay/ >
  );
}
export default Audio;